// import React from "react";
// import "./about.scss";

// const education = [
//   {
//     degree: "MSc Human-Computer Interaction",
//     school: "University College London",
//     grade: "Distinction",
//   },
//   {
//     degree: "BSc Computer Science",
//     school: "University of Lancaster",
//     grade: "2:1",
//   },
// ];

// const languages = [
//   { language: "English", level: "Fluent" },
//   { language: "Chinese", level: "Native" },
// ];

// export default function About() {
//   return (
//     <div className="about" id="about">
//       <div className="about__inner">
//         <div className="about__grid">
//           <section className="about__col about__col--intro">
//             <h2 className="about__eyebrow">About Me</h2>
//             <h1 className="about__title">
//               UX/UI Designer with <span>Frontend</span>
//             </h1>
//             <p className="about__description">
//               I am a Front-End and UX/UI Designer, passionate about transforming
//               creative ideas into seamless and intuitive digital experiences. I
//               focus on crafting interfaces that are visually engaging and highly
//               usable, ensuring every interaction feels natural and meaningful.
//               My work spans websites, mobile applications, and interactive
//               interfaces, reflecting a careful balance of user needs, interaction
//               logic, and overall usability.
//             </p>
//             <p className="about__description">
//               By bridging design and development, I bring concepts to life
//               through functional, interactive features. Combining hands-on
//               coding with user-centered design thinking, I create digital
//               experiences that are both practical and impactful, delivering
//               value and enjoyment to users.
//             </p>
//           </section>

//           <section className="about__col about__col--education">
//             <h3 className="about__sectionTitle">Education</h3>
//             <div className="about__timeline">
//               <div className="about__timelineLine" aria-hidden="true" />
//               <ul className="about__timelineList">
//                 {education.map((item, i) => (
//                   <li key={i} className="about__timelineItem">
//                     <span className="about__timelineNode" aria-hidden="true" />
//                     <div className="about__timelineContent">
//                       <p className="about__timelineDegree">{item.degree}</p>
//                       <p className="about__timelineSchool">{item.school}</p>
//                       <p className="about__timelineGrade">{item.grade}</p>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <div className="about__languages">
//               <h4 className="about__languagesTitle">Languages</h4>
//               <ul className="about__languagesList">
//                 {languages.map((item, i) => (
//                   <li key={i} className="about__languageItem">
//                     <span className="about__languageName">{item.language}</span>
//                     <span className="about__languageSeparator">·</span>
//                     <span className="about__languageLevel">{item.level}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import "./about.scss";

const education = [
  {
    degree: "MSc Human-Computer Interaction",
    school: "University College London",
    grade: "Distinction",
  },
  {
    degree: "BSc Computer Science",
    school: "Lancaster University",
    grade: "2:1",
  },
  {
    degree: "A-Level Mathematics",
    school: "St Peter's RC High School, Gloucester",
    grade: "A",
  },
];
const languages = [
  { language: "English", level: "Fluent" },
  { language: "Chinese", level: "Native" },
];

export default function About() {
  return (
    <div className="about" id="about">
      <div className="about__inner">
        <div className="about__grid">
          <section className="about__col about__col--intro">
            <h2 className="about__eyebrow">About</h2>

            <h1 className="about__title">
              Software Engineer with <span>UX Perspective</span>
            </h1>

            <p className="about__description">
              I am a software engineer with a background in Computer Science and
              Human-Computer Interaction. My work focuses on solving complex
              problems by combining analytical thinking, system design, and
              practical software development.
            </p>

            <p className="about__description">
              I enjoy breaking down complex systems, understanding how different
              components interact, and building solutions that are efficient,
              maintainable, and practical.
            </p>

            <p className="about__description">
              With training in both computer science and HCI, I bring a balanced
              perspective to software development — combining strong technical
              reasoning with an awareness of how people interact with
              technology.
            </p>
          </section>

          <section className="about__col about__col--education">
            <h3 className="about__sectionTitle">Education</h3>

            <div className="about__timeline">
              <div className="about__timelineLine" aria-hidden="true" />

              <ul className="about__timelineList">
                {education.map((item, i) => (
                  <li key={i} className="about__timelineItem">
                    <span className="about__timelineNode" aria-hidden="true" />

                    <div className="about__timelineContent">
                      <p className="about__timelineDegree">{item.degree}</p>

                      <p className="about__timelineSchool">{item.school}</p>

                      <p className="about__timelineGrade">{item.grade}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="about__languages">
              <h4 className="about__languagesTitle">Languages</h4>

              <ul className="about__languagesList">
                {languages.map((item, i) => (
                  <li key={i} className="about__languageItem">
                    <span className="about__languageName">{item.language}</span>

                    <span className="about__languageSeparator">·</span>

                    <span className="about__languageLevel">{item.level}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
